// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flow-tips[data-v-0e7d0f40]{max-width:700px;margin:0 auto 16px}.flow-tips__item[data-v-0e7d0f40]{text-align:left;margin-bottom:10px;display:flex;align-items:baseline;gap:10px}.flow-tips__icon[data-v-0e7d0f40]{font-size:18px}.flow-groups-container[data-v-0e7d0f40]{max-height:272px;margin:30px auto}", ""]);
// Exports
module.exports = exports;
